(function () {
  var SELECTOR = "[data-agb-shipping-preview]";
  var POLL_DELAY_MS = 500;
  var MAX_POLL_ATTEMPTS = 20;
  var CACHE_TTL_MS = 4000;
  var STORAGE_KEY = "agbSelectedShippingRate";
  var DEFAULT_COPY = {
    subtotalLabel: "Subtotal",
    availableRates: "Estimated shipping options:",
    estimatedTotal: "EST. TOTAL",
    checkoutNotice: "Tax calculated at checkout. Choose your final shipping method at checkout.",
    checkoutReminderPrefix: "At checkout, select:",
    empty: "Shipping rates will appear once there is an item in the cart.",
    loading: "Loading shipping rates...",
    unavailable: "Shipping rates are unavailable right now."
  };

  function getContext(container) {
    return (container.getAttribute("data-context") || "page").toLowerCase();
  }

  function getMoneyFormat(container) {
    var format = container.getAttribute("data-money-format") || "";

    if (!/\{\{.*\}\}/.test(format) && window.money_format && /\{\{.*\}\}/.test(window.money_format)) {
      return window.money_format;
    }

    return format || window.money_format || "${{amount}}";
  }

  function formatMoney(cents, moneyFormat) {
    var safeMoneyFormat = getMoneyFormat({
      getAttribute: function () {
        return moneyFormat || "";
      }
    });

    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      try {
        return window.Shopify.formatMoney(cents, safeMoneyFormat);
      } catch (error) {}
    }

    return "$" + (cents / 100).toFixed(2);
  }

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (character) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[character];
    });
  }

  function buildAddress(container) {
    return {
      country: container.getAttribute("data-country") || "United States",
      province: container.getAttribute("data-province") || "New York",
      zip: container.getAttribute("data-zip") || "11417"
    };
  }

  function encodeAddress(address) {
    if (window.jQuery && typeof window.jQuery.param === "function") {
      return window.jQuery.param({
        shipping_address: address
      });
    }

    var params = new URLSearchParams();
    params.append("shipping_address[country]", address.country);
    params.append("shipping_address[province]", address.province);
    params.append("shipping_address[zip]", address.zip);
    return params.toString();
  }

  function getSavedRateName() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) || "";
    } catch (error) {
      return "";
    }
  }

  function saveRateName(rateName) {
    try {
      if (rateName) {
        window.localStorage.setItem(STORAGE_KEY, rateName);
      } else {
        window.localStorage.removeItem(STORAGE_KEY);
      }
    } catch (error) {}
  }

  function fetchCart() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error("Unable to load cart.");
      }

      return response.json();
    });
  }

  function requestRates(address, cart, browsingCountry) {
    var addressQuery = encodeAddress(address);
    var rateCountry = address.country === "Canada" ? "CA" : "US";
    var marketQuery = "country=" + rateCountry;
    var requestKey = JSON.stringify([addressQuery, browsingCountry, cart && cart.currency, cart && cart.total_price,
      (cart && cart.items || []).map(function (item) {
        return [item.key || item.variant_id, item.quantity, item.final_line_price, item.sku, item.properties];
      })]);
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
    if (window.__agbShippingRatesPromise && window.__agbShippingRatesPromiseKey === requestKey) {
      return window.__agbShippingRatesPromise;
    }

    if (
      window.__agbShippingRatesCache &&
      window.__agbShippingRatesCache.key === requestKey &&
      window.__agbShippingRatesCache.timestamp &&
      Date.now() - window.__agbShippingRatesCache.timestamp < CACHE_TTL_MS
    ) {
      return Promise.resolve(window.__agbShippingRatesCache.rates || []);
    }

    var pending = new Promise(function (resolve, reject) {
      function finalizeSuccess(rates) {
        window.__agbShippingRatesCache = {
          key: requestKey,
          rates: rates || [],
          timestamp: Date.now()
        };
        resolve(rates || []);
      }

      function pollRates(attempt) {
        fetch(root + "cart/async_shipping_rates.json?" + addressQuery + "&" + marketQuery, {
          credentials: "same-origin",
          headers: {
            Accept: "application/json"
          }
        }).then(function (pollResponse) {
          if (!pollResponse.ok) {
            throw new Error("Unable to fetch shipping rates.");
          }

          return pollResponse.json();
        }).then(function (data) {
          if (data && Array.isArray(data.shipping_rates)) {
            finalizeSuccess(data.shipping_rates);
            return;
          }

          if (attempt >= MAX_POLL_ATTEMPTS) {
            reject(new Error("Timed out waiting for shipping rates."));
            return;
          }

          window.setTimeout(function () {
            pollRates(attempt + 1);
          }, POLL_DELAY_MS);
        }).catch(reject);
      }

      fetch(root + "cart/prepare_shipping_rates.json?" + marketQuery, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Accept: "application/json"
        },
        body: addressQuery
      }).then(function (response) {
        if (!response.ok) {
          throw new Error("Unable to prepare shipping rates.");
        }
        pollRates(0);
      }).catch(reject);
    }).finally(function () {
      // Country-aware Ajax calls can set the market cookie; keep browsing unchanged.
      if (/^(US|CA)$/.test(browsingCountry || "") && browsingCountry !== rateCountry) {
        return fetch(root + "cart.js?country=" + browsingCountry, {
          credentials: "same-origin", headers: { Accept: "application/json" }
        }).then(function (response) {
          if (!response.ok) throw new Error("Unable to restore browsing market.");
        });
      }
    }).finally(function () {
      if (window.__agbShippingRatesPromise === pending) {
        window.__agbShippingRatesPromise = null;
        window.__agbShippingRatesPromiseKey = null;
      }
    });
    window.__agbShippingRatesPromise = pending;
    window.__agbShippingRatesPromiseKey = requestKey;
    return pending;
  }

  function getContainers(context) {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTOR)).filter(function (container) {
      return getContext(container) === context;
    });
  }

  function getSelectedShippingCents(container) {
    var groupName = container.dataset.rateGroup || "";
    if (!groupName) {
      return 0;
    }

    var checked = container.querySelector('input[name="' + groupName + '"]:checked');
    return checked ? parseInt(checked.getAttribute("data-rate-cents"), 10) || 0 : 0;
  }

  function updateEstimatedTotal(container, subtotalCents, moneyFormat) {
    var totalNode = container.querySelector("[data-agb-estimated-total]");
    if (!totalNode) {
      return;
    }

    totalNode.textContent = formatMoney(subtotalCents + getSelectedShippingCents(container), moneyFormat);
  }

  function updateCheckoutReminder(container, selectedRateName) {
    var reminderNode = container.querySelector("[data-agb-checkout-reminder]");
    if (!reminderNode) {
      return;
    }

    if (selectedRateName) {
      reminderNode.innerHTML = DEFAULT_COPY.checkoutReminderPrefix + ' <strong>' + escapeHtml(selectedRateName) + '</strong>';
    } else {
      reminderNode.textContent = "";
    }
  }

  function buildLocalDate(year, monthIndex, day) {
    return new Date(year, monthIndex, day, 0, 0, 0, 0);
  }

  function parseSharedContextDate(value) {
    if (!value || typeof value !== "string") {
      return null;
    }

    var parts = value.split("-");
    if (parts.length !== 3) {
      return null;
    }

    return buildLocalDate(
      parseInt(parts[0], 10),
      parseInt(parts[1], 10) - 1,
      parseInt(parts[2], 10)
    );
  }

  function getActiveHoliday(now) {
    var context = window.AGBHolidayContext;

    if (!context || !context.activeHoliday) {
      return "";
    }

    var activeHoliday = context.activeHoliday;
    var startDate = parseSharedContextDate(activeHoliday.startDate);
    var endDate = parseSharedContextDate(activeHoliday.endDate);
    var eventDate = parseSharedContextDate(activeHoliday.eventDate);

    if (!startDate || !endDate || !eventDate || now < startDate || now > endDate) {
      return "";
    }

    var eventTime = buildEasternDate(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate(), 0, 0, 0);
    var daysUntil = (eventTime - now) / 86400000;
    if (!(daysUntil > 0 && daysUntil <= 14)) {
      return "";
    }

    return {
      name: activeHoliday.name,
      eventDate: eventDate,
      startDate: startDate,
      endDate: endDate
    };
  }

  var easternFormatter = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false
  });

  function getEasternOffsetMs(date) {
    var parts = easternFormatter.formatToParts(date).reduce(function (acc, part) {
      acc[part.type] = part.value;
      return acc;
    }, {});
    var easternTime = Date.UTC(
      parseInt(parts.year, 10),
      parseInt(parts.month, 10) - 1,
      parseInt(parts.day, 10),
      parseInt(parts.hour, 10) % 24,
      parseInt(parts.minute, 10),
      parseInt(parts.second, 10)
    );

    return easternTime - date.getTime();
  }

  function buildEasternDate(year, monthIndex, day, hour, minute, second) {
    var wallTimeAsUtc = new Date(Date.UTC(year, monthIndex, day, hour, minute, second));
    var easternTime = new Date(wallTimeAsUtc.getTime());

    return new Date(wallTimeAsUtc.getTime() - getEasternOffsetMs(easternTime));
  }

  function isBusinessDay(date) {
    var day = date.getDay();
    return day !== 0 && day !== 6;
  }

  function subtractBusinessDays(date, businessDays) {
    var result = new Date(date.getTime());
    var remaining = businessDays;

    while (remaining > 0) {
      result.setDate(result.getDate() - 1);

      if (isBusinessDay(result)) {
        remaining -= 1;
      }
    }

    return result;
  }

  function buildCutoff(date) {
    return buildEasternDate(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0);
  }

  function getHolidayShippingRules(holidayName) {
    var context = window.AGBHolidayContext;

    if (!context || !context.shippingRules || !context.shippingRules.standard) {
      return null;
    }

    if (holidayName === "Christmas" && context.shippingRules.christmas) {
      return context.shippingRules.christmas;
    }

    return context.shippingRules.standard;
  }

  function getRateRuleKey(rateName) {
    var name = String(rateName || "").toLowerCase();

    if (name.indexOf("saturday") !== -1) {
      return "";
    }

    if (name.indexOf("ground") !== -1 || name.indexOf("standard") !== -1) {
      return "ground";
    }

    if (name.indexOf("3rd") !== -1 || name.indexOf("3 day") !== -1 || name.indexOf("three") !== -1) {
      return "third";
    }

    if (name.indexOf("2nd") !== -1 || name.indexOf("2 day") !== -1 || name.indexOf("two") !== -1) {
      return "second";
    }

    if (name.indexOf("next") !== -1 || name.indexOf("overnight") !== -1 || name.indexOf("1 day") !== -1) {
      return "next";
    }

    return "";
  }

  function getHolidayRateMessage(rateName, activeHoliday, now) {
    var ruleKey = getRateRuleKey(rateName);

    if (!activeHoliday || !ruleKey) {
      return "";
    }

    var rules = getHolidayShippingRules(activeHoliday.name);
    var businessDays = rules ? rules[ruleKey] : null;

    if (!businessDays) {
      return "";
    }

    var shipDate = subtractBusinessDays(activeHoliday.eventDate, businessDays);
    var cutoff = buildCutoff(shipDate);
    var messageClass = now <= cutoff ? "is-valid" : "is-passed";
    var messageText = now <= cutoff ? "Estimated arrival before " + activeHoliday.name : "Holiday delivery cutoff passed";

    return '<span class="agb-rate-preview__holiday-note ' + messageClass + '">' + messageText + '</span>';
  }

  function renderShell(container, subtotalCents, moneyFormat, ratesHtml, hasRates) {
    container.dataset.subtotalCents = String(subtotalCents || 0);

    container.innerHTML =
      '<div class="agb-rate-preview__summary">' +
        '<div class="agb-rate-preview__shipping-row agb-rate-preview__shipping-row--subtotal">' +
          '<span>' + DEFAULT_COPY.subtotalLabel + ':</span>' +
          '<span>' + formatMoney(subtotalCents, moneyFormat) + '</span>' +
        '</div>' +
      '</div>' +
      '<div class="agb-rate-preview__rates">' +
        '<div class="agb-rate-preview__title">' + DEFAULT_COPY.availableRates + '</div>' +
        ratesHtml +
        '<div class="agb-rate-preview__notice">' + DEFAULT_COPY.checkoutNotice + '</div>' +
        '<div class="agb-rate-preview__checkout-reminder" data-agb-checkout-reminder></div>' +
      '</div>' +
      '<div class="agb-rate-preview__total">' +
        '<div class="agb-rate-preview__total-label">' + (hasRates ? DEFAULT_COPY.estimatedTotal : DEFAULT_COPY.subtotalLabel) + '</div>' +
        '<div class="agb-rate-preview__total-value" data-agb-estimated-total>' + formatMoney(subtotalCents, moneyFormat) + '</div>' +
      '</div>';
  }

  function renderEmpty(container, subtotalCents, moneyFormat) {
    container.dataset.agbShippingRequest = String(Number(container.dataset.agbShippingRequest || 0) + 1);
    renderShell(
      container,
      subtotalCents,
      moneyFormat,
      '<div class="agb-rate-preview__empty">' + DEFAULT_COPY.empty + '</div>'
    );
  }

  function renderLoading(container, subtotalCents, moneyFormat) {
    renderShell(
      container,
      subtotalCents,
      moneyFormat,
      '<div class="agb-rate-preview__loading">' + DEFAULT_COPY.loading + '</div>'
    );
  }

  function renderError(container, subtotalCents, moneyFormat) {
    renderShell(
      container,
      subtotalCents,
      moneyFormat,
      '<div class="agb-rate-preview__error">' + DEFAULT_COPY.unavailable + '</div>'
    );
  }

  function syncVisiblePreviews(selectedRateName, sourceContainer) {
    Array.prototype.slice.call(document.querySelectorAll(SELECTOR)).forEach(function (container) {
      if (container === sourceContainer) {
        return;
      }

      var radios = container.querySelectorAll('input[type="radio"][data-rate-name]');
      if (!radios.length) {
        return;
      }

      var matched = false;
      radios.forEach(function (radio) {
        var isMatch = radio.getAttribute("data-rate-name") === selectedRateName;
        radio.checked = isMatch;
        matched = matched || isMatch;
      });

      if (matched) {
        updateEstimatedTotal(
          container,
          parseInt(container.dataset.subtotalCents || "0", 10),
          getMoneyFormat(container)
        );
        updateCheckoutReminder(container, selectedRateName);
      }
    });
  }

  function bindRateSelection(container, subtotalCents, moneyFormat) {
    container.onchange = function (event) {
      var target = event.target;
      if (!target || target.type !== "radio") {
        return;
      }

      var selectedRateName = target.getAttribute("data-rate-name") || "";
      saveRateName(selectedRateName);
      updateEstimatedTotal(container, subtotalCents, moneyFormat);
      updateCheckoutReminder(container, selectedRateName);
      syncVisiblePreviews(selectedRateName, container);
    };
  }

  function normalizeCanadaRates(container, rates) {
    if ((container.getAttribute("data-country") || "").toLowerCase() !== "canada") {
      return rates || [];
    }

    var economyCents = parseInt(container.getAttribute("data-canada-economy-cents") || "0", 10);
    var expressCents = parseInt(container.getAttribute("data-canada-express-cents") || "0", 10);

    return (rates || []).map(function (rate) {
      var normalizedRate = {};
      Object.keys(rate || {}).forEach(function (key) {
        normalizedRate[key] = rate[key];
      });

      if (/economy/i.test(normalizedRate.name || "") && economyCents > 0) {
        normalizedRate.price = (economyCents / 100).toFixed(2);
      } else if (/express/i.test(normalizedRate.name || "") && expressCents > 0) {
        normalizedRate.price = (expressCents / 100).toFixed(2);
      }

      return normalizedRate;
    });
  }

  function merchandiseSubtotal(cart) {
    if (!cart) return 0;
    var subtotal = cart.items_subtotal_price;
    if (typeof subtotal !== "number" && cart.items && cart.items.every(function (item) { return typeof item.final_line_price === "number"; })) {
      subtotal = cart.items.reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
    }
    if (typeof subtotal !== "number") return typeof cart.total_price === "number" ? cart.total_price : 0;
    var discounts = (cart.cart_level_discount_applications || []).reduce(function (sum, discount) {
      return sum + (Number(discount.total_allocated_amount) || 0);
    }, 0);
    return Math.max(0, subtotal - discounts);
  }

  function renderRates(container, cart, rates) {
    rates = normalizeCanadaRates(container, rates);
    var subtotalCents = merchandiseSubtotal(cart);
    var moneyFormat = getMoneyFormat(container);
    var preferredRateName = getSavedRateName();
    var sortedRates = (rates || []).slice().sort(function (left, right) {
      return parseFloat(left.price) - parseFloat(right.price);
    });
    var groupName = "agb-rate-option-" + Math.random().toString(36).slice(2);
    var hasPreferredRate = sortedRates.some(function (rate) {
      return preferredRateName && preferredRateName === rate.name;
    });
    var activeHoliday = getActiveHoliday(new Date());
    var now = new Date();

    if (!sortedRates.length) {
      renderError(container, subtotalCents, moneyFormat);
      container.dataset.agbShippingReady = "true";
      return;
    }

    var optionsHtml = sortedRates.map(function (rate, index) {
      var cents = Math.round(parseFloat(rate.price) * 100);
      var checked = hasPreferredRate ? preferredRateName === rate.name : index === 0;
      var holidayMessage = getHolidayRateMessage(rate.name, activeHoliday, now);
      return (
        '<label class="agb-rate-preview__option">' +
          '<input type="radio" name="' + groupName + '" data-rate-cents="' + cents + '" data-rate-name="' + rate.name.replace(/"/g, "&quot;") + '"' + (checked ? " checked" : "") + '>' +
          '<span class="agb-rate-preview__name-wrap">' +
            '<span class="agb-rate-preview__name">' + rate.name + '</span>' +
            holidayMessage +
          '</span>' +
          '<span class="agb-rate-preview__price">' + formatMoney(cents, moneyFormat) + '</span>' +
        '</label>'
      );
    }).join("");

    container.dataset.rateGroup = groupName;
    renderShell(container, subtotalCents, moneyFormat, optionsHtml, true);
    bindRateSelection(container, subtotalCents, moneyFormat);

    var selectedInput = container.querySelector('input[name="' + groupName + '"]:checked');
    if (selectedInput) {
      var selectedRateName = selectedInput.getAttribute("data-rate-name") || "";
      saveRateName(selectedRateName);
      updateCheckoutReminder(container, selectedRateName);
    }

    updateEstimatedTotal(container, subtotalCents, moneyFormat);
    container.dataset.agbShippingReady = "true";
  }

  function currentPreviewContext(container, cart) {
    var canada = (cart.items || []).some(function (item) { return /-CA$/i.test(item.sku || ""); });
    if (!canada) {
      return Promise.resolve({"data-country": "United States", "data-province": "New York", "data-zip": "11417"});
    }
    // Drawer markup can predate the first add. Re-render Liquid to read current supplier tags.
    var key = JSON.stringify([cart.currency, cart.total_price, cart.items.map(function (item) {
      return [item.key, item.quantity, item.final_line_price];
    })]);
    if (!window.__agbCanadaContext || window.__agbCanadaContext.key !== key) {
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
      var pending = fetch(root + "cart", {credentials: "same-origin", cache: "no-store"}).then(function (response) {
        if (!response.ok) throw new Error("Cart context unavailable");
        return response.text();
      }).then(function (html) {
        var preview = new DOMParser().parseFromString(html, "text/html").querySelector(SELECTOR + '[data-context="page"]');
        if (!preview || preview.getAttribute("data-country") !== "Canada") throw new Error("Cart context changed");
        var attributes = {};
        ["data-country", "data-province", "data-zip", "data-canada-economy-cents", "data-canada-express-cents", "data-money-format"].forEach(function (name) {
          attributes[name] = preview.getAttribute(name) || "";
        });
        return attributes;
      });
      window.__agbCanadaContext = {key: key, promise: pending};
      pending.catch(function () {
        if (window.__agbCanadaContext && window.__agbCanadaContext.promise === pending) window.__agbCanadaContext = null;
      });
    }
    return window.__agbCanadaContext.promise;
  }

  function loadContainer(container, cart) {
    if (!container) {
      return;
    }

    var subtotalCents = merchandiseSubtotal(cart);
    var moneyFormat = getMoneyFormat(container);
    var requestId = String(Number(container.dataset.agbShippingRequest || 0) + 1);
    container.dataset.agbShippingRequest = requestId;

    container.dataset.agbShippingLoading = "true";
    renderLoading(container, subtotalCents, moneyFormat);

    currentPreviewContext(container, cart).then(function (attributes) {
      if (container.dataset.agbShippingRequest !== requestId) return [];
      Object.keys(attributes).forEach(function (name) { container.setAttribute(name, attributes[name]); });
      return requestRates(buildAddress(container), cart, container.getAttribute("data-browsing-country"));
    }).then(function (rates) {
      if (container.dataset.agbShippingRequest !== requestId) return;
      renderRates(container, cart, rates || []);
    }).catch(function () {
      if (container.dataset.agbShippingRequest !== requestId) return;
      renderError(container, subtotalCents, moneyFormat);
      container.dataset.agbShippingReady = "true";
    }).finally(function () {
      if (container.dataset.agbShippingRequest === requestId) {
        container.dataset.agbShippingLoading = "false";
      }
    });
  }

  function loadPagePreviews(force, cart) {
    var pageContainers = getContainers("page");

    pageContainers.forEach(function (container) {
      if (force) {
        container.dataset.agbShippingReady = "";
      }

      if (container.dataset.agbShippingReady === "true") {
        return;
      }

      loadContainer(container, cart);
    });
  }

  function loadDrawerPreviews(force, cart) {
    var drawerContainers = getContainers("drawer");

    drawerContainers.forEach(function (container) {
      if (force) {
        container.dataset.agbShippingReady = "";
      }

      if (container.dataset.agbShippingReady === "true") {
        return;
      }

      loadContainer(container, cart);
    });
  }

  function refreshDrawerPreviews(cart) {
    window.__agbLastCart = cart || null;
    window.__agbShippingRatesCache = null;

    if (!cart || !cart.items || !cart.items.length) {
      getContainers("drawer").forEach(function (container) {
        renderEmpty(container, 0, getMoneyFormat(container));
        container.dataset.agbShippingReady = "true";
      });
      return;
    }

    loadDrawerPreviews(true, cart);
  }

  function queueDrawerPreviewBoot() {
    var attempts = 0;

    window.clearInterval(window.__agbDrawerPreviewBootTimer);
    window.__agbDrawerPreviewBootTimer = window.setInterval(function () {
      attempts += 1;

      if (!document.body || !document.body.classList.contains("js-drawer-open-right")) {
        window.clearInterval(window.__agbDrawerPreviewBootTimer);
        return;
      }

      if (!getContainers("drawer").length) {
        if (attempts >= 15) {
          window.clearInterval(window.__agbDrawerPreviewBootTimer);
        }
        return;
      }

      window.clearInterval(window.__agbDrawerPreviewBootTimer);
      fetchCart().then(function (cart) {
        refreshDrawerPreviews(cart);
      }).catch(function () {
        getContainers("drawer").forEach(function (container) {
          renderError(container, 0, getMoneyFormat(container));
          container.dataset.agbShippingReady = "true";
        });
      });
    }, 120);
  }

  function refreshPagePreviews() {
    window.__agbShippingRatesCache = null;
    fetchCart().then(function (cart) {
      window.__agbLastCart = cart;

      if (!cart || !cart.items || !cart.items.length) {
        getContainers("page").forEach(function (container) {
          renderEmpty(container, 0, getMoneyFormat(container));
          container.dataset.agbShippingReady = "true";
        });
        return;
      }

      loadPagePreviews(true, cart);
    }).catch(function () {
      getContainers("page").forEach(function (container) {
        renderError(container, 0, getMoneyFormat(container));
        container.dataset.agbShippingReady = "true";
      });
    });
  }

  function bindEvents() {
    var quantitySave = null;
    var quantityFailed = false;
    var quantityTimer = null;
    var editedQuantity = null;

    function savePageQuantity(input) {
      window.clearTimeout(quantityTimer);
      quantityTimer = null;
      editedQuantity = null;
      var form = input.closest("#cart_form");
      var row = input.closest(".cart__row");
      var editor = row && row.querySelector("[data-cart-line-editor]");
      if (!form || !editor || quantitySave) return;
      var quantity = Math.max(1, Math.min(99, parseInt(input.value, 10) || 1));
      input.value = String(quantity);
      var status = row.querySelector("[data-cart-line-editor-status]");
      if (status) { status.textContent = "Updating quantity..."; status.setAttribute("role", "status"); }
      var inputs = form.querySelectorAll(".cart-quantity-input");
      Array.prototype.forEach.call(inputs, function (field) { field.disabled = true; });
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
      quantitySave = fetch(root + "cart/change.js", {
        method: "POST", credentials: "same-origin",
        headers: {"Content-Type": "application/json", "Accept": "application/json"},
        body: JSON.stringify({line: Number(editor.getAttribute("data-line")), quantity: quantity})
      }).then(function (response) {
        if (!response.ok) throw new Error("Quantity update failed");
        return response.json();
      }).then(function (cart) {
        quantityFailed = false;
        window.__agbLastCart = cart;
        Array.prototype.forEach.call(document.querySelectorAll(".CartCount"), function (count) { count.textContent = cart.item_count; });
        cart.items.forEach(function (item, index) {
          var line = form.querySelector('[data-cart-line-editor][data-line="' + (index + 1) + '"]');
          var lineRow = line && line.closest(".cart__row");
          if (!lineRow) return;
          line.setAttribute("data-quantity", item.quantity);
          lineRow.querySelector(".cart-quantity-input").value = item.quantity;
          var amount = lineRow.querySelector(".amount");
          if (amount) amount.textContent = formatMoney(item.final_line_price, getMoneyFormat(getContainers("page")[0]));
        });
        window.__agbShippingRatesCache = null;
        loadPagePreviews(true, cart);
        if (status) status.textContent = "";
      }).catch(function () {
        quantityFailed = true;
        if (status) { status.textContent = "Could not update quantity. Please change it again before checkout."; status.setAttribute("role", "alert"); }
        throw new Error("Quantity was not saved");
      }).finally(function () {
        Array.prototype.forEach.call(inputs, function (field) { field.disabled = false; });
        quantitySave = null;
      });
      quantitySave.catch(function () {});
    }

    document.addEventListener("input", function (event) {
      var input = event.target;
      if (!input || !input.matches("#cart_form .cart-quantity-input")) return;
      editedQuantity = input;
      window.clearTimeout(quantityTimer);
      quantityTimer = window.setTimeout(function () { savePageQuantity(input); }, 600);
    }, true);

    document.addEventListener("change", function (event) {
      var input = event.target;
      if (!input || !input.matches("#cart_form .cart-quantity-input")) return;
      event.stopImmediatePropagation();
      savePageQuantity(input);
    }, true);

    window.addEventListener("click", function (event) {
      var button = event.target && event.target.closest("#cart_form .cart-quantity-add, #cart_form .cart-quantity-remove");
      if (button) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (quantitySave) return;
        var input = button.closest(".product-quantity__item").querySelector(".cart-quantity-input");
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + (button.matches(".cart-quantity-add") ? 1 : -1));
        savePageQuantity(input);
        return;
      }
      var checkout = event.target && event.target.closest('#cart_form a[name="checkout"]');
      if (checkout && !quantitySave) {
        var unsaved = Array.prototype.find.call(document.querySelectorAll("#cart_form .cart-quantity-input"), function (field) {
          var editor = field.closest(".cart__row").querySelector("[data-cart-line-editor]");
          return editor && Number(field.value) !== Number(editor.getAttribute("data-quantity"));
        });
        if (unsaved) savePageQuantity(unsaved);
      }
      if (checkout && editedQuantity) savePageQuantity(editedQuantity);
      if (checkout && (quantitySave || quantityFailed)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (quantitySave) quantitySave.then(function () { checkout.click(); }).catch(function () {});
      }
    }, true);

    document.addEventListener("click", function (event) {
      var qtyButton = event.target && event.target.closest("#CartDrawer .ajaxcart__qty-adjust");
      if (!qtyButton) {
        return;
      }

      var qtyInput = qtyButton.parentElement && qtyButton.parentElement.querySelector(".ajaxcart__qty-num");
      if (!qtyInput) {
        return;
      }

      var currentQty = parseInt((qtyInput.value || "").replace(/\D/g, ""), 10);
      if (isNaN(currentQty) || currentQty < 0) {
        currentQty = 0;
      }

      var nextQty = qtyButton.classList.contains("ajaxcart__qty--plus") ? currentQty + 1 : Math.max(currentQty - 1, 0);

      qtyInput.value = String(nextQty);
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
      event.preventDefault();
      event.stopPropagation();
    }, true);

    document.addEventListener("click", function (event) {
      var target = event.target;
      if (!target) {
        return;
      }

      if (target.closest("a.site-header__cart-toggle.js-drawer-open-right")) {
        queueDrawerPreviewBoot();
      }

      if (
        target.closest(".cart-quantity-add") ||
        target.closest(".cart-quantity-remove") ||
        target.closest(".cart__remove")
      ) {
        window.setTimeout(refreshPagePreviews, 500);
      }
    });

    document.addEventListener("change", function (event) {
      var target = event.target;
      if (!target) {
        return;
      }

      if (target.matches(".cart-quantity-input")) {
        window.setTimeout(refreshPagePreviews, 500);
      }
    });

    if (window.jQuery) {
      window.jQuery(document.body).on("afterCartLoad.ajaxCart", function (event, cart) {
        refreshDrawerPreviews(cart);
      });
    }
  }

  function bindDrawerObserver() {
    if (typeof MutationObserver === "undefined" || !document.body) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      var drawerPreviewAdded = false;
      var drawerOpened = false;

      mutations.forEach(function (mutation) {
        if (mutation.type === "attributes" && mutation.target === document.body) {
          if (document.body.classList.contains("js-drawer-open-right")) {
            drawerOpened = true;
          }
        }

        if (mutation.type === "childList" && mutation.addedNodes && mutation.addedNodes.length) {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (!node || node.nodeType !== 1) {
              return;
            }

            if (
              node.matches &&
              node.matches(SELECTOR + '[data-context="drawer"]')
            ) {
              drawerPreviewAdded = true;
              return;
            }

            if (
              node.querySelector &&
              node.querySelector(SELECTOR + '[data-context="drawer"]')
            ) {
              drawerPreviewAdded = true;
            }
          });
        }
      });

      if (!drawerPreviewAdded && !drawerOpened) {
        return;
      }

      if (!document.body.classList.contains("js-drawer-open-right")) {
        return;
      }

      queueDrawerPreviewBoot();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  function init() {
    refreshPagePreviews();
    bindEvents();
    bindDrawerObserver();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.AGBShippingPreview = {
    refreshAll: function () {
      refreshPagePreviews();
      if (window.__agbLastCart) {
        loadDrawerPreviews(true, window.__agbLastCart);
      }
    }
  };
})();
